import {
  File,
  FileDoc,
  FileImage,
  FilePdf,
  FileXls,
} from "@phosphor-icons/react";

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
};

export const getFileIcon = (mimeType: string) => {
  if (mimeType.includes("pdf")) {
    return <FilePdf className="h-5 w-5 text-red-500" weight="duotone" />;
  }
  if (mimeType.includes("image")) {
    return <FileImage className="h-5 w-5 text-blue-500" weight="duotone" />;
  }
  if (mimeType.includes("word") || mimeType.includes("document")) {
    return <FileDoc className="h-5 w-5 text-blue-600" weight="duotone" />;
  }
  if (mimeType.includes("excel") || mimeType.includes("spreadsheet")) {
    return <FileXls className="h-5 w-5 text-green-600" weight="duotone" />;
  }
  return <File className="h-5 w-5 text-gray-500" weight="duotone" />;
};

export const getFileTypeLabel = (mimeType: string): string => {
  if (mimeType.includes("pdf")) return "PDF";
  if (mimeType.includes("png")) return "PNG";
  if (mimeType.includes("jpeg") || mimeType.includes("jpg")) return "JPEG";
  if (mimeType.includes("gif")) return "GIF";
  if (mimeType.includes("word")) return "Word";
  if (mimeType.includes("excel") || mimeType.includes("spreadsheet"))
    return "Excel";
  if (mimeType.includes("text/plain")) return "Tekst";
  if (mimeType.includes("csv")) return "CSV";
  return "Bestand";
};

export const getConfidenceColor = (confidence: number): string => {
  if (confidence >= 0.9) return "text-green-600 bg-green-50";
  if (confidence >= 0.7) return "text-amber-600 bg-amber-50";
  if (confidence >= 0.5) return "text-orange-600 bg-orange-50";
  return "text-red-600 bg-red-50";
};

export const isPdfFile = (mimeType: string, fileName?: string): boolean => {
  if (mimeType && mimeType.toLowerCase().includes("pdf")) {
    return true;
  }
  if (fileName && fileName.toLowerCase().endsWith(".pdf")) {
    return true;
  }
  return false;
};
